import axios from "axios";
import { SERVICES_URL } from "../env";

const API_URL = `${SERVICES_URL}/users`;

export const getUserInfo = (): Promise<any> => axios.get(`${API_URL}/loggedIn`).then((response) => response.data);
export const getAllUsers = (): Promise<any> => axios.get(`${API_URL}/all`).then((response) => response.data);
export const assignRole = (role, userId): Promise<any> =>
  axios.post(`${API_URL}/${userId}/assignRole/${role}`).then((response) => response.data);
